export default __webpack_public_path__ + "static/media/second_two_page_birth_certificate.45c43b1f.jpg";